@if (this.activeTab() === this.CommunicationType.Mail && this.tos && this.ccs) {
  <div class="recipients flex-column g-space-xs">
    <div [hidden]="this.collapsed()">
      <div class="recipients__row flex-row align-center g-space-sm">
        <cam-text class="recipients__label" size="sm" color="brand-secondary">
          {{ 'communication.message.input.to' | translate }}
        </cam-text>
        <cam-input-choices class="full-width" [input]="this.tos"></cam-input-choices>
        <cam-button-tool size="xs" [state]="this.withCc() ? 'selected' : 'classic'" (action)="this.toggleCc()">
          {{ 'communication.message.input.cc' | translate }}
        </cam-button-tool>
        <cam-button-tool size="xs" icon="arrow-big-top" (action)="this.collapsed.set(true)"></cam-button-tool>
      </div>

      <div class="recipients__row flex-row align-center g-space-sm" [hidden]="!this.withCc()">
        <cam-text class="recipients__label" size="sm" color="brand-secondary">
          {{ 'communication.message.input.cc' | translate }}
        </cam-text>
        <cam-input-choices class="full-width" [input]="this.ccs"></cam-input-choices>
      </div>
    </div>

    @if (this.collapsed()) {
      <div class="recipients__row align-center flex-row g-space-sm c-pointer" (click)="this.collapsed.set(false)">
        @if (this.outputCorrespondentInput.length > 0) {
          <div class="recipients__chips flex-row align-center g-space-xs">
            @for (correspondent of this.outputCorrespondentInput; track correspondent) {
              @let correspondentValue = this.getCorrespondent(correspondent);
              <div class="recipient-chip flex-row align-center g-space-xs">
                <cam-user-logo
                  [user]="{
                    picture: correspondentValue.picture,
                    firstName: correspondentValue.firstName,
                    lastName: correspondentValue.lastName,
                    trigram: correspondentValue.trigram,
                  }"
                  size="sm"
                  defaultType="trigram"
                ></cam-user-logo>
                <cam-text size="sm"> {{ correspondentValue.firstName }} {{ correspondentValue.lastName }} </cam-text>
              </div>
            }
          </div>
        } @else {
          <cam-text size="sm" color="brand-secondary">
            {{ 'communication.message.input.no-recipient' | translate }}
          </cam-text>
        }
        <cam-button-tool
          size="xs"
          icon="arrow-big-bottom"
          class="justify-end"
          (action)="this.collapsed.set(false)"
        ></cam-button-tool>
      </div>
    }
  </div>
}

<ng-template #choicesTemplate let-data="data">
  <div class="p-space-sm">
    @if (this.isEmail(data.search)) {
      <cam-link (action)="this.addCustomEmail(data.search, data.select, data.refresh)">
        {{ 'communication.message.input.add' | translate }}
      </cam-link>
    }
  </div>
  <div class="p-space-sm">
    <cam-menu-navigation
      [menu]="this.menu"
      container="tags"
      [options]="{
        spaceElement: 'xs',
      }"
    ></cam-menu-navigation>
  </div>
  @if ((data.search?.length ?? 0) < 3 && this.selected !== 'participant') {
    <div class="p-space-sm">
      {{ 'communication.message.input.min-search' | translate }}
    </div>
  }
  @if ((data.search?.length ?? 0) >= 3 || this.selected === 'participant') {
    <cam-empty [isEmpty]="this.filteredItems(data.items).length === 0">
      @for (option of this.filteredItems(data.items); track option) {
        <div
          class="flex-row pointer m-space-sm p-space-sm"
          [class.is-selected]="data.isselected(option)"
          (click)="data.select(option)"
        >
          @let item = option.data;
          <div class="flex-row align-center g-space-sm">
            <cam-user-logo
              [userInfo]="{
                profilePictureUrl: item.picture,
                naming: {
                  firstName: item.firstName,
                  name: item.lastName,
                  trigram: item.trigram,
                },
              }"
              size="md"
              defaultType="font"
            ></cam-user-logo>
            {{ item.firstName }} {{ item.lastName }}
          </div>
        </div>
      }
    </cam-empty>
  }
</ng-template>
